import { Styles } from '@core-ui/radio/types/types';
import {
  CSSObject,
  forBrands,
  getFontWeight,
  Theme,
} from '@core-ui/react-stitch';

const setCustomRadioStylesForBananaRepublic = (theme: Theme): CSSObject => ({
  labelText: {
    color: theme.color.b2,
  },
  radioButton: {
    borderColor: theme.color.b2,
  },
});

const setCustomRadioBackgroundStylesForBananaRepublic = (
  theme: Theme
): string => theme.color.b2;

export const displayWrapperStyleForBananaRepublic = (): CSSObject => ({
  label: {
    marginBottom: '1rem',
  },
});

export const displayWrapperStylesForAllBrands = () => ({
  label: {
    marginBottom: '1.5rem',
  },
});

const setDisplayItemStylesForBananaRepublic = (theme: Theme): CSSObject => ({
  label: {
    color: theme.color.b2,
    fontWeight: getFontWeight('regular').fontWeight,
  },
});

export const displayItemStyle = (theme: Theme): CSSObject => ({
  display: 'flex',
  justifyContent: 'center',
  width: '33%',
  marginBottom: '1rem',
  ...(forBrands(theme, {
    br: setDisplayItemStylesForBananaRepublic,
    brfs: setDisplayItemStylesForBananaRepublic,
  }) as CSSObject),
});

export const customBackgroundColorForRadio = (theme: Theme) =>
  forBrands(theme, {
    br: setCustomRadioBackgroundStylesForBananaRepublic,
    brfs: setCustomRadioBackgroundStylesForBananaRepublic,
    default: () => '',
  }) as string;

export const customRadioStyles = (theme: Theme) =>
  forBrands(theme, {
    br: setCustomRadioStylesForBananaRepublic,
    brfs: setCustomRadioStylesForBananaRepublic,
  }) as Styles;
